import { combineReducers } from 'redux'
import { eduCommissionsCurrentDataReducer } from './data/eduCommissionsCurrentDataReducer'
import { eduCommissionsMembersReducer } from './members/eduCommissionsMembersReducer'

export const currentReducer = combineReducers({
  data:    eduCommissionsCurrentDataReducer,
  members: eduCommissionsMembersReducer,
})
